import { g as i } from "../../utils-BOfnFgIH.js";
import { I as s } from "../../constants-DeVuDy8J.js";
import { createElementBlock as n, openBlock as r, normalizeClass as l, createElementVNode as t } from "vue";
import { _ as c } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const d = {
  name: "DtIconInstagram",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(s).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return s[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = i();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], u = ["fill"], f = ["fill"], p = /* @__PURE__ */ t("path", {
  d: "M12 5.7c-1.71 0-1.925.007-2.597.038-.67.03-1.129.137-1.53.293-.414.16-.765.376-1.115.726s-.566.702-.727 1.116c-.157.4-.263.859-.293 1.53-.03.671-.038.886-.038 2.597 0 1.711.008 1.925.038 2.597.03.67.137 1.129.293 1.53.16.414.376.765.726 1.115s.702.566 1.116.727c.4.156.859.262 1.53.293.671.03.886.038 2.597.038 1.71 0 1.925-.008 2.597-.038.67-.03 1.129-.137 1.53-.293.414-.16.765-.376 1.115-.727.35-.35.566-.701.727-1.116.155-.4.261-.858.293-1.529.03-.672.038-.886.038-2.597 0-1.711-.008-1.926-.038-2.598-.032-.67-.138-1.128-.293-1.529a3.09 3.09 0 0 0-.727-1.116c-.35-.35-.7-.565-1.116-.726-.401-.156-.86-.262-1.53-.293-.672-.03-.886-.038-2.597-.038H12Zm-.565 1.135h.566c1.682 0 1.881.006 2.545.037.615.028.948.13 1.17.217.294.114.504.25.724.47.22.221.357.431.471.725.087.222.19.555.217 1.17.03.664.037.863.037 2.545 0 1.68-.006 1.88-.037 2.544-.028.615-.13.948-.216 1.17a1.949 1.949 0 0 1-.472.724c-.22.22-.43.357-.724.47-.222.087-.555.19-1.17.218-.664.03-.863.037-2.545.037-1.683 0-1.882-.007-2.546-.037-.614-.028-.948-.131-1.17-.217a1.952 1.952 0 0 1-.725-.472c-.22-.22-.357-.43-.471-.724-.086-.221-.189-.555-.217-1.169-.03-.664-.036-.864-.036-2.546s.006-1.88.036-2.545c.028-.614.13-.948.217-1.17.114-.294.251-.504.471-.724.221-.22.431-.357.725-.472.222-.086.556-.189 1.17-.217a35 35 0 0 1 1.98-.035v.001Zm3.928 1.046a.756.756 0 1 0 0 1.513.756.756 0 0 0 0-1.513Zm-3.362.884a3.235 3.235 0 1 0 0 6.47 3.235 3.235 0 0 0 0-6.47ZM12 9.9a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2Z",
  fill: "#fff"
}, null, -1), h = ["id"], m = /* @__PURE__ */ t("stop", { "stop-color": "#FD5" }, null, -1), g = /* @__PURE__ */ t("stop", {
  offset: ".1",
  "stop-color": "#FD5"
}, null, -1), I = /* @__PURE__ */ t("stop", {
  offset: ".5",
  "stop-color": "#FF543E"
}, null, -1), b = /* @__PURE__ */ t("stop", {
  offset: "1",
  "stop-color": "#C837AB"
}, null, -1), q = [
  m,
  g,
  I,
  b
], D = ["id"], S = /* @__PURE__ */ t("stop", { "stop-color": "#3771C8" }, null, -1), Z = /* @__PURE__ */ t("stop", {
  offset: ".128",
  "stop-color": "#3771C8"
}, null, -1), C = /* @__PURE__ */ t("stop", {
  offset: "1",
  "stop-color": "#60F",
  "stop-opacity": "0"
}, null, -1), v = [
  S,
  Z,
  C
];
function y(a, F, o, $, w, e) {
  return r(), n("svg", {
    "aria-label": o.ariaLabel,
    class: l([e.iconSizeClass, "d-icon d-icon--instagram"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Instagram",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    t("path", {
      d: "M12.003 3c-3.757 0-4.856.004-5.07.022-.771.064-1.25.185-1.774.445-.402.2-.72.433-1.034.758-.57.593-.917 1.322-1.042 2.19-.061.42-.079.506-.082 2.656-.002.717 0 1.66 0 2.925 0 3.756.004 4.854.022 5.067.062.75.18 1.223.429 1.74a3.792 3.792 0 0 0 2.457 2.007c.371.096.78.149 1.307.173.223.01 2.495.017 4.768.017 2.273 0 4.546-.003 4.763-.014.61-.029.963-.076 1.354-.177a3.768 3.768 0 0 0 2.457-2.012c.245-.504.369-.994.425-1.706.012-.155.017-2.628.017-5.097 0-2.47-.006-4.938-.018-5.093-.056-.723-.18-1.209-.433-1.723a3.57 3.57 0 0 0-.77-1.055c-.595-.57-1.324-.915-2.191-1.04-.42-.061-.505-.08-2.656-.083h-2.93Z",
      fill: `url(#${a.uniqueID}a)`
    }, null, 8, u),
    t("path", {
      d: "M12.003 3c-3.757 0-4.856.004-5.07.022-.771.064-1.25.185-1.774.445-.402.2-.72.433-1.034.758-.57.593-.917 1.322-1.042 2.19-.061.42-.079.506-.082 2.656-.002.717 0 1.66 0 2.925 0 3.756.004 4.854.022 5.067.062.75.18 1.223.429 1.74a3.792 3.792 0 0 0 2.457 2.007c.371.096.78.149 1.307.173.223.01 2.495.017 4.768.017 2.273 0 4.546-.003 4.763-.014.61-.029.963-.076 1.354-.177a3.768 3.768 0 0 0 2.457-2.012c.245-.504.369-.994.425-1.706.012-.155.017-2.628.017-5.097 0-2.47-.006-4.938-.018-5.093-.056-.723-.18-1.209-.433-1.723a3.57 3.57 0 0 0-.77-1.055c-.595-.57-1.324-.915-2.191-1.04-.42-.061-.505-.08-2.656-.083h-2.93Z",
      fill: `url(#${a.uniqueID}b)`
    }, null, 8, f),
    p,
    t("defs", null, [
      t("radialGradient", {
        id: `${a.uniqueID}a`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(0 -17.8393 16.592 0 7.781 22.386)"
      }, q, 8, h),
      t("radialGradient", {
        id: `${a.uniqueID}b`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(1.56512 7.81915 -32.23086 6.45148 -.015 4.298)"
      }, v, 8, D)
    ])
  ], 10, _);
}
const O = /* @__PURE__ */ c(d, [["render", y]]);
export {
  O as default
};
//# sourceMappingURL=instagram.js.map
